<template>
  <div>
    <div class="banner"
         style="padding-top: 86px">
      <div class="EC_width">
        <div class="display_between">
          <div class="leftBan">
            <img :src="apiData.banner.headImg">
            <p class="name">{{apiData.banner.name}}</p>
            <p class="signName">{{apiData.banner.sign}}</p>
            <div class="showInfor">
              <img src="/image/quanke/inforImg.png"
                   class="marginRight5"><span>{{apiData.banner.msgNum}}</span>
              <img src="/image/quanke/xianshiImg.png"
                   class="marginLeft20 marginRight5"><span>{{apiData.banner.seeNum}}</span>
            </div>
          </div>
          <div class="rightBan">
            <img src="/image/quanke/signbg.png"
                 class="signBg">
            <span class="signBtnRed">专家名片</span>
            <span class="signBtnblue marginLeft10">+订阅</span>
            <p class="rightTitle">{{apiData.banner.introTitle}}</p>
            <p>学术专长：{{apiData.banner.skill}}</p>
            <div class="border_bottom_18">
            </div>
            <div class="titleContent">
              {{apiData.banner.intro}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="EC_width">
      <div class="gl_title_bar marginTop50">
        <div class="gl_tb_left">
          <span class="normaltitle">TA的推荐</span>
          <a href="javascript:;"
             class="gl_pad_btn gl_pad_btn_active marginLeft10">全部</a>
          <a href="javascript:;"
             class="gl_pad_btn marginLeft10">最新</a>
          <a href="javascript:;"
             class="gl_pad_btn marginLeft10">最热</a>
        </div>
        <div class="gl_tb_right">
          <a href="javascript:;"
             class="gl_tb_right_more"><img src="/image/index/xuanzhuan.png"
                 class="marginRight5"><span class="redColor">换一批</span></a>
        </div>
      </div>
      <div class="display_between marginTop20 marginBottom50">
        <div class="pub_square"
             v-for="(item,index) in apiData.recommend.data"
             :key="index">
          <div class="pubs_img">
            <img :src="item.img">
          </div>
          <div class="pubs_body">
            <div class="pubs_title">
              {{item.title}}
            </div>
            <div class="pubs_label display_between">
              <div>
                <span v-for="(itemn,indexn) in item.sign"
                      :key="indexn">{{itemn}}</span>
              </div>
              <div class="pubs_cancel">
                取消收藏
              </div>
            </div>
            <div class="display_between">
              <div class="pubs_tip">
                <span class="redColor">{{item.price}}</span>
              </div>
              <div class="pubs_rentou">
                <img src="/image/geren/ren.png">{{item.num}}人
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grayBg">
      <div class="EC_width">
        <div class="gl_title_bar marginTop50">
          <div class="gl_tb_left">
            <span class="normaltitle">TA的课程</span>
            <a href="javascript:;"
               class="gl_pad_btn gl_pad_btn_active marginLeft10">全部</a>
            <a href="javascript:;"
               class="gl_pad_btn marginLeft10">指南解读</a>
            <a href="javascript:;"
               class="gl_pad_btn marginLeft10">呼吸系统疾病（7）</a>
          </div>
          <div class="gl_tb_right">
            <a href="javascript:;"
               class="gl_tb_right_more"><img src="/image/index/moreimg.png"
                   class="marginRight5">更多</a>
          </div>
        </div>
        <div class="display_between marginTop20"
             v-for="(item,index) in userlist"
             :key="index">
          <div class="pub_square"
               v-for="(itemn,indexn) in item"
               :key="indexn">
            <div class="pubs_img">
              <img :src="itemn.img">
            </div>
            <div class="pubs_body">
              <div class="pubs_title">
                {{itemn.title}}
              </div>
              <div class="pubs_label display_between">
                <div>
                  <span v-for="(itemx,indexx) in itemn.sign"
                        :key="indexx">{{itemx}}</span>
                </div>
                <div class="pubs_cancel">
                  取消收藏
                </div>
              </div>
              <div class="display_between">
                <div class="pubs_tip">
                  <span class="redColor">{{itemn.price}}</span>
                </div>
                <div class="pubs_rentou">
                  <img src="/image/geren/ren.png">{{itemn.num}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 60px 0;">
      <div class="EC_width">
        <div class="gl_title_vertical_line gl_title_v_line_active"
             style="font-size: 24px;font-weight: bold;">
          TA的学术
        </div>
        <div class="display_flex">
          <div class="leftCanvas">
            <img src="/image/quanke/oracl.png">
            <span>论文著作</span>
            <span class="normalColor fontsize22">217</span>
            <span class="normalColor">篇/本</span>
          </div>
          <div class="rightList">
            <div class="marginBottom30"
                 v-for="(item,index) in apiData.learning.list"
                 :key="index">
              <p class="normalColor fontsize16 marginBottom10">{{item.name}}</p>
              <div class="gl_title_vertical_line gl_title_v_line_active fontBold fontsize22 marginBottom10">
                {{item.title}}
              </div>
              <p>{{item.year}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from "lodash"
export default {
  name: "qkExpert",
  data () {
    return {
      apiData: {},
      userlist: []
    }
  },
  created () {
    this.getData()

  },
  methods: {
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        var usedata = data.qkExpert.course.data;
        that.userlist = lodash.chunk(usedata, 4);
        that.apiData = data.qkExpert
      })
    },
  }
}
</script>

<style scoped>
.content {
    flex: 1;
}

.banner {
    height: 526px;
    background: url(/image/quanke/bannernew.png) center no-repeat;
    box-sizing: border-box;
}

.leftBan {
    left: 195px;
}

.name {
    font-size: 26px;
    color: #ffffff;
    font-weight: bold;
    text-align: center;
    margin-top: 20px;
}

.signName {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    margin-top: 10px;
}

.showInfor {
    width: 195px;
    height: 36px;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.008);
    border-radius: 18px;
    box-sizing: border-box;
    padding: 10px 0;
    text-align: center;
    color: #fff;
    margin-top: 20px;
}

.rightBan {
    background: url(/image/quanke/bgTop.png) center no-repeat;
    width: 1005px;
    height: 412px;
    position: relative;
    padding-left: 67px;
    padding-right: 88px;
    box-sizing: border-box;
    padding-top: 34px;
}

.signBg {
    position: absolute;
    top: -47px;
    right: 76px;
}

.signBtnRed {
    display: inline-block;
    width: 130px;
    height: 30px;
    background: #df0018;
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-weight: bold;
    color: #ffffff;
}
.signBtnblue {
    display: inline-block;
    width: 130px;
    height: 30px;
    background: #dff3f4;
    border: 1px solid #0b8586;
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-weight: bold;
    color: #0b8586;
}
.rightTitle {
    color: #0b8586;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    margin-top: 25px;
    margin-bottom: 19px;
}
.titleContent {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    margin-top: 20px;
}
.grayBg {
    background: #f6f7fb;
    padding: 60px 0;
}
.leftCanvas {
    flex: 1;
}
.rightList {
    width: 516px;
    height: 340px;
    overflow: auto;
    margin-left: 60px;
}
.rightList::-webkit-scrollbar {
    width: 5px;
    background: transparent;
}

/* 滚动槽 */
.rightList::-webkit-scrollbar-track {
    border-radius: 10px;
}

/* 滚动条滑块 */
.rightList::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #0b8586;
}

.rightList::-webkit-scrollbar-thumb:window-inactive {
    background: #0b8586;
}
</style>
